// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const enviarSmsService = async (data: any) => {
  const URL = `${Globais.DOMINIOBACK}/sms/enviar`;

  console.log("Enviando SMS com os dados:", data);
  try {
    const response = await axios.post(URL, data);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
